document.getElementById("formBuscador").addEventListener("submit", function(e) {

    const input = document.getElementById("buscador");

    let valor = input.value.trim();

    if (!valor) {
        return;
    }

    // Normalizar texto
    valor = valor
        .toLowerCase()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "");

    // Separar palabras
    let palabras = valor.split(/\s+/);

    // Limpiar vacías
    palabras = palabras.filter(Boolean);

    // Singularizar
    palabras = palabras.map(palabra => {

        if (palabra.length > 4) {

            if (palabra.endsWith("es")) {
                palabra = palabra.slice(0, -2);
            }
            else if (palabra.endsWith("s")) {
                palabra = palabra.slice(0, -1);
            }

        }

        return palabra;

    });

    // Diccionario de equivalencias
    const equivalencias = {

        comedor: [
            "comedor",
            "antecomedor"
        ],

        antecomedor: [
            "antecomedor",
            "comedor"
        ],

        sala: [
            "sala",
            "salas",
            "sofa",
            "sofas",
            "sillon",
            "sillones"
        ],

        sofa: [
            "sofa",
            "sofas",
            "sillon",
            "sillones",
            "sala",
            "salas"
        ],

        sillon: [
            "sillon",
            "sillones",
            "sofa",
            "sofas",
            "sala",
            "salas"
        ],

        recamara: [
            "recamara",
            "recamaras",
            "cama",
            "camas"
        ],

        cama: [
            "cama",
            "camas",
            "recamara",
            "recamaras"
        ],

        buro: [
            "buro",
            "buró",
            "buros",
            "burós"
        ],

        litera: ["litera"],
        cantina: ["cantina"],
        taburete: ["taburete"],
        banco: ["banco"],
        escritorio: ["escritorio"],
        mesa: ["mesa"],
        silla: ["silla"],
        consola: ["consola"],
        credenza: ["credenza"],
        vitrina: ["vitrina"],
        mueble: ["mueble"]

    };

    let terminosBusqueda = [];

    palabras.forEach(palabra => {

        // Agregar la palabra original
        terminosBusqueda.push(palabra);

        // Agregar búsqueda por prefijo
        if (palabra.length >= 2) {
            terminosBusqueda.push(`${palabra}*`);
        }

        // Agregar equivalencias
        if (equivalencias[palabra]) {

            equivalencias[palabra].forEach(eq => {

                terminosBusqueda.push(eq);

                if (eq.length >= 2) {
                    terminosBusqueda.push(`${eq}*`);
                }

            });

        }

    });

    // Eliminar duplicados
    terminosBusqueda = [...new Set(terminosBusqueda)];

    // Construir consulta Shopify
    const query = terminosBusqueda.join(" OR ");

    input.value = query;

});



document.addEventListener("DOMContentLoaded", function(){


    const botonQR = document.getElementById("botonQR");


    console.log("QR cargado:", botonQR);


    if(!botonQR){
        return;
    }


    botonQR.addEventListener("click", function(e){

        e.preventDefault();

        console.log("Click QR");


        iniciarScanner();


    });


});



async function iniciarScanner(){

console.log("ENTRÓ AL SCANNER");
    if(!("BarcodeDetector" in window)){

        alert("Este navegador no soporta lector QR.");
        return;

    }


    const input = document.getElementById("buscador");
    const form = document.getElementById("formBuscador");


    try{


        const detector = new BarcodeDetector({
            formats:["qr_code"]
        });



        const video = document.createElement("video");


        video.style.position="fixed";
        video.style.top="0";
        video.style.left="0";
        video.style.width="100%";
        video.style.height="100%";
        video.style.zIndex="999999";
        video.style.background="#000";


        document.body.appendChild(video);



        const stream = await navigator.mediaDevices.getUserMedia({

            video:{
                facingMode:"environment"
            }

        });



        video.srcObject = stream;

        await video.play();



        async function leerQR(){


            try{


                const codes = await detector.detect(video);


                if(codes.length){


                    const resultado = codes[0].rawValue;


                    console.log("QR:", resultado);



                    stream.getTracks().forEach(track=>{
                        track.stop();
                    });


                    video.remove();



                    input.value = resultado;


                    form.submit();


                    return;

                }


            }catch(e){

                console.log(e);

            }



            requestAnimationFrame(leerQR);


        }


        leerQR();



    }catch(error){

        console.error(error);

        alert("No se pudo abrir la cámara. Revisa permisos.");

    }


}